<mat-toolbar class="topbar">
  <button mat-icon-button id="sidenavToggle" (click)="toggleSidenav()" matTooltip="Toggle Hide/Open">
    <mat-icon>menu</mat-icon>
  </button>
  <!-- <span class="example-fill-remaining-space"></span>
  <div fxFlex="10" class="pl-1"> 
    <button mat-icon-button  (click)="fileUploadDropZoneDlg()"  matTooltip="Upload Files">
      <mat-icon>cloud_upload</mat-icon>
    </button>
  </div> -->
  <!-- <button mat-icon-button class="example-fill-remaining-space"  (click)="newAlert()" matTooltip="New Alert">
    <mat-icon>notifications</mat-icon>
  </button> -->
  <button mat-icon-button class="topbar-button-right"  (click)="logout()" matTooltip="Signout">
    <mat-icon>exit_to_app</mat-icon>
  </button>
</mat-toolbar>  

 
  <!-- Top right user menu -->
  
  <mat-menu #accountMenu="matMenu">

    <button mat-menu-item [routerLink]="['admin/tickets']">
      <mat-icon>devices</mat-icon>
      <span>My Development Requests</span>
    </button> 

    <button mat-menu-item *ngIf="releaseNotesEnabled" (click)="showReleaseNotes()">
      <mat-icon>campaign</mat-icon>
      <span>What's New</span>
    </button>

    <button mat-menu-item [routerLink]="['reviews/pages/about-dash']">
      <mat-icon>article</mat-icon>
      <span>About Dash</span>
    </button>
    
    <button mat-menu-item (click)="refreshJobList()">
      <mat-icon>sync</mat-icon>
      <span>Refresh Job List</span>
    </button> 
    
    <button mat-menu-item (click)="clearIndexDB()">
      <mat-icon>settings_backup_restore</mat-icon>
      <span>Reset Local Data</span>
    </button> 
    
    
    <button mat-menu-item (click)="logout()">
      <mat-icon>exit_to_app</mat-icon>
      <span>Sign out</span>
    </button>
  </mat-menu>

  <button mat-icon-button type="button" style="color:white;position:absolute;top:10px;right:10px;" [matMenuTriggerFor]="accountMenu">
    <mat-icon>settings</mat-icon>
  </button>


